export default __webpack_public_path__ + "static/media/mapa.4cc38c85.png";